import { I18n } from "@/i18n";
import { queryToString } from "@/router/Router";

type Props = {
  children?: any;
  locale?: boolean;
  query?: Record<string, string>;
  className?: string;
} & JSX.IntrinsicElements["a"];

export default function Link({ children, href, locale = true, query, className, ...rest }: Props) {
  const _href = `${href}${queryToString(query)}`;
  const link = locale ? `/${I18n.locale}${_href === "/" ? "" : _href}` : _href;
  return (
    <a href={href ? link : undefined} className={className} {...rest}>
      {children}
    </a>
  );
}
